import { useEffect } from 'react'
import './PlayerModal.css'

function PlayerModal({ videoUrl, hasNext, onClickNext, hasPrev, onClickPrev, onClickClose }: { videoUrl: string, hasNext: boolean, onClickNext: () => void, hasPrev: boolean, onClickPrev: () => void, onClickClose: () => void }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);
  const getVideoType = () => {
    if (videoUrl.includes("youtube.com")) {
      return "youtube";
    } else if (videoUrl.includes("vimeo.com")) {
      return "vimeo";
    } else {
      return "local";
    }
  }
  const onLocalClickNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClickNext();
  }
  const onLocalClickPrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClickPrev();
  }
  return (
    <div className="PlayerModal" onClick={onClickClose}>
      <div className="close-button" onClick={onClickClose}>&times;</div>
      {hasNext && <div className="next-button" onClick={onLocalClickNext}>&rsaquo;</div>}
      {hasPrev && <div className="prev-button" onClick={onLocalClickPrev}>&lsaquo;</div>}
      <div className="content">
        {getVideoType() === "local" ?
          <video className="video-player" controls autoPlay src={videoUrl}></video> :
          <div className='iframe-container'>

            <iframe
              className="video-player"
              src={getVideoType() === "youtube" ? videoUrl.replace("watch?v=", "embed/") : videoUrl.replace("vimeo.com/", "player.vimeo.com/video/")}
              title={getVideoType() === "youtube" ? "YouTube video player" : "Vimeo video player"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          }

      </div>
    </div>
  )
}

export default PlayerModal